/**
 * Hosen Quick-Win — Chip-Tooltips
 *
 * Auf Desktop reicht das CSS (:hover, :focus-visible). Auf Touch-Geraeten
 * loest ein Tap auf den Chip stattdessen ein Toggle der .is-tip-open-Klasse
 * aus, weil Mobile-Browser :hover nur kurz beim Tap feuern und der Tooltip
 * sonst direkt wieder verschwindet.
 *
 * Plus: Boundary-Detection — kurz bevor der Tooltip sichtbar wird, messen
 * wir die effektive Breite des ::after-Elements und schieben es so, dass es
 * nicht ueber den Viewport-Rand schiesst (--qw-tip-shift via inline style).
 *
 * Zusaetzlich:
 *   - Tap ausserhalb eines offenen Chips schliesst alle Tooltips
 *   - ESC schliesst alle Tooltips
 *   - Enter / Space togglet den fokussierten Chip (Keyboard-Nutzer)
 */
(function () {
  if (typeof document === 'undefined') return;

  var SEL = '.qw-chips__item--has-tip';
  var OPEN_CLASS = 'is-tip-open';
  var SAFE_MARGIN = 8;

  /**
   * Berechne horizontalen Shift so, dass der ::after-Tooltip vollstaendig
   * innerhalb des Viewports liegt. Wir lesen die computed width des
   * Pseudo-Elements aus (funktioniert in allen modernen Browsern).
   */
  function adjustTooltipShift(chip) {
    if (!chip || !chip.getBoundingClientRect) return;

    var rect = chip.getBoundingClientRect();
    var viewport = document.documentElement.clientWidth || window.innerWidth;
    var chipCenter = rect.left + rect.width / 2;

    var tipWidth = 240;
    if (window.getComputedStyle) {
      try {
        var after = window.getComputedStyle(chip, '::after');
        var w = parseFloat(after.width);
        if (isFinite(w) && w > 0) tipWidth = w;
      } catch (e) { /* Fallback bleibt 240 */ }
    }

    var desiredLeft = chipCenter - tipWidth / 2;
    var desiredRight = chipCenter + tipWidth / 2;
    var shift = 0;

    if (desiredRight > viewport - SAFE_MARGIN) {
      shift = (viewport - SAFE_MARGIN) - desiredRight;
    } else if (desiredLeft < SAFE_MARGIN) {
      shift = SAFE_MARGIN - desiredLeft;
    }

    chip.style.setProperty('--qw-tip-shift', Math.round(shift) + 'px');
  }

  function closeAll(except) {
    var open = document.querySelectorAll(SEL + '.' + OPEN_CLASS);
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== except) open[i].classList.remove(OPEN_CLASS);
    }
  }

  // Boundary-Detection auf mouseenter + focusin (vor dem Anzeigen)
  document.addEventListener('mouseenter', function (e) {
    if (!e.target || !e.target.matches) return;
    if (e.target.matches(SEL)) adjustTooltipShift(e.target);
  }, true);

  document.addEventListener('focusin', function (e) {
    if (!e.target || !e.target.matches) return;
    if (e.target.matches(SEL)) adjustTooltipShift(e.target);
  });

  // Click / Tap-Toggle
  document.addEventListener('click', function (e) {
    var chip = e.target.closest ? e.target.closest(SEL) : null;
    if (chip) {
      var willOpen = !chip.classList.contains(OPEN_CLASS);
      closeAll(chip);
      if (willOpen) {
        adjustTooltipShift(chip);
        chip.classList.add(OPEN_CLASS);
      } else {
        chip.classList.remove(OPEN_CLASS);
      }
    } else {
      closeAll(null);
    }
  });

  // Keyboard-Bedienung
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      closeAll(null);
      return;
    }
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      var active = document.activeElement;
      if (active && active.classList && active.classList.contains('qw-chips__item--has-tip')) {
        e.preventDefault();
        var willOpen = !active.classList.contains(OPEN_CLASS);
        closeAll(active);
        if (willOpen) {
          adjustTooltipShift(active);
          active.classList.add(OPEN_CLASS);
        }
      }
    }
  });

  // Re-shift fuer aktuell offene Tooltips bei Resize/Orientierungswechsel
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var open = document.querySelectorAll(SEL + '.' + OPEN_CLASS);
      for (var i = 0; i < open.length; i++) adjustTooltipShift(open[i]);
    }, 100);
  });
})();
